import { Component, Input } from "@angular/core";
import { MaterialModule } from "src/app/app.materials";

@Component({
  selector: "app-spinner",
  templateUrl: "./spinner.component.html",
  styleUrls: ["./spinner.component.scss"],
  standalone: true,
  imports: [MaterialModule],
})
export class SpinnerComponent {
  @Input() isLoading: boolean;
}
